/*
  ============================================================
  iFixiCare Homepage JavaScript
  File: assets/ifixicare-home.js

  HOW TO USE:
  In layout/theme.liquid, just before </body>, add:
  {{ 'ifixicare-home.js' | asset_url | script_tag }}
  ============================================================
*/

document.addEventListener('DOMContentLoaded', function () {

  /* ── SCROLL REVEAL ── */
  const ro = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry, i) {
      if (entry.isIntersecting) {
        setTimeout(function() {
          entry.target.classList.add('in');
        }, i * 65);
      }
    });
  }, { threshold: 0.09 });

  document.querySelectorAll('.ifc-reveal').forEach(function(el) {
    ro.observe(el);
  });

  /* ── NAV SHADOW ON SCROLL ── */
  var nav = document.getElementById('ifc-nav');
  if (nav) {
    window.addEventListener('scroll', function() {
      if (window.scrollY > 30) {
        nav.style.boxShadow = '0 4px 28px rgba(0,0,0,.65)';
      } else {
        nav.style.boxShadow = 'none';
      }
    });
  }

  /* ── HAMBURGER TOGGLE & DYNAMIC POSITIONING ── */
  var ham = document.getElementById('ifc-ham');
  var mmenu = document.getElementById('ifc-mmenu');
  var nav = document.getElementById('ifc-nav');

  if (ham && mmenu && nav) {
    var updateMenuTop = function() {
      var rect = nav.getBoundingClientRect();
      mmenu.style.top = rect.bottom + 'px';
    };

    ham.addEventListener('click', function() {
      updateMenuTop();
      mmenu.classList.toggle('open');
      ham.classList.toggle('open');
    });

    window.addEventListener('scroll', function() {
      if (mmenu.classList.contains('open')) {
        updateMenuTop();
      }
    });

    window.addEventListener('resize', function() {
      if (mmenu.classList.contains('open')) {
        updateMenuTop();
      }
    });
  }

  /* ── CLOSE MOBILE MENU ON LINK CLICK ── */
  if (mmenu) {
    mmenu.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', function() {
        mmenu.classList.remove('open');
        if (ham) ham.classList.remove('open');
      });
    });
  }

});
